export function executeWithTime(method, name) {
  console.time(name);
  let result = method();
  console.timeEnd(name);
  return result;
}
